/* eslint-disable no-useless-escape */

import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import PropTypes from 'prop-types'

class Link extends React.Component {
  getHostname (url) {
    const matches = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)
    return matches && matches[1]
  }

  prependDomain () {
    const href = this.props.href
    const { host } = window.location

    if (!href.match('^(https|http)')) {
      const url = `https://${host}${href}`
      return url
    }

    return this.props.href
  }

  isExternalLink () {
    const href = this.prependDomain(this.props.href)
    const url = new URL(href)
    const currentUrl = new URL(window.location.href)
    return url.host !== currentUrl.host
  }

  render () {
    const { className, children } = this.props
    if (!this.isExternalLink()) {
      const url = this.props.href.replace(/^.*\/\/[^\/]+/, '')
      return (
        <RouterLink
          to={url}
          className={className}
        >
          {children}
        </RouterLink>
      )
    }
    return (
      <a href={this.props.href} className={className} target="_blank" rel="noreferrer noopener">
        {children}
      </a>
    )
  }
}

Link.propTypes = {
  children: PropTypes.any,
  href: PropTypes.string.isRequired,
  theme: PropTypes.string,
  className: PropTypes.string
}

export default Link
